import { createContext } from "react";

const MenusContext = createContext();

export default MenusContext;
